import { uploadDocument } from '@/api/upload-document/UploadDocument'
import { useUpdateDocuments } from '@/api/update-document/UpdateDocuments'
const useMerchantDocuments = () => {
  const { mutateAsync: updateMutate } = useUpdateDocuments()

  const upload = (file: File, documentType: string) =>
    uploadDocument(file, documentType)

  const update = async (
    documentId: number,
    file: File,
    documentType: string
  ) => {
    const file_extension = file.type.split('/').at(1) ?? ''
    const response = await updateMutate({
      file,
      file_extension,
      document_type: documentType,
      document_id: documentId
    })
    return response.data
  }

  return {
    upload,
    update
  }
}

export default useMerchantDocuments
